import { Component, OnInit } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { validateForm } from "src/app/shared/validators";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "formly-field-surveyinput",
    styleUrls: ["./common.css"],
    template: `<ng-container
      ><mat-form-field appearance="fill" floatLabel="always">
      <mat-label>{{
        props.question?.identifierText || "Enter text below"
      }}</mat-label>
      <input
        matInput
        type="text"
        class="form-field"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [required]="props.question?.isRequired"
        [disabled]="props.disabled"
        (keyup)="onKeyUpEvent($event)"
        />
        <mat-hint class="error" align="start">{{
          getErrorMessage(props.question?.id)
        }}</mat-hint>
      </mat-form-field>
      @if (props.question?.showCommentBox) {
        <br />
        <mat-form-field appearance="fill" floatLabel="always" class="comments">
          <mat-label>Comments</mat-label>
          <textarea
            [id]="props.question?.id + '-comments'"
            [ngModel]="commentModel"
            rows="4"
            class="form-field"
            matInput
            (blur)="onBlurEvent($event)"
            [disabled]="props.disabled"
          ></textarea>
        </mat-form-field>
      }
    </ng-container>`,
    standalone: false
})
export class FormlyFieldSurveyInputComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit
{
  public commentModel: string;
  commentKey: string;
  subject = new Subject();

  getErrorMessage(key: string): string {
    return validateForm(this.form, key);
  }

  ngOnInit(): void {
    this.commentKey = this.key.toString() + "-comments";
    this.commentModel = this.model[this.commentKey] || "";

    this.subject.pipe(debounceTime(1000)).subscribe((value) => {
      this.formControl.setValue(value, { emitEvent: false }); //this needs to NOT emit event or it tries to double save and causes collision in the database
      this.formControl.updateValueAndValidity();
    });
  }

  onBlurEvent(event: any) {
    this.model[this.commentKey] = event.target.value;
    this.formControl.updateValueAndValidity();
  }

  onKeyUpEvent(event: any) {
    this.subject.next(event.target.value);
  }
}
